import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_IMAGE_FRAME } from './mobileMotion'

export default function Slide6M() {
  const { t } = useLanguage()
  const s = t.slides.slide6

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.h2
        {...fadeScaleProps(0.06)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.1)} className={M_IMAGE_FRAME}>
        <img
          src="/slides/slide_06.png"
          alt=""
          className="block w-full"
          loading="lazy"
          decoding="async"
        />
      </motion.div>

      <div className="flex flex-col gap-4">
        {s.bullets?.map((b, i) => (
          <motion.div
            key={b.title}
            {...fadeScaleProps(0.14 + i * 0.06)}
            className="rounded-xl bg-white p-4 shadow-sm ring-1 ring-[#1B2A6B]/[0.06]"
          >
            <h3 className="mb-2 text-[17px] font-semibold leading-snug text-[#1B2A6B]">
              {b.title}
            </h3>
            <p className="text-[16px] leading-relaxed text-[#1B2A6B]/65">{b.body}</p>
          </motion.div>
        ))}
      </div>
    </MobileSlideShell>
  )
}
